import { Component, h } from '@stencil/core';

@Component({
  tag: 'lilu-payment-methods',
  styleUrl: 'lilu-payment-methods.scss',
  shadow: true,
})
export class LiluPaymentMethods {
  render() {
    return (
      <div class="payments">
        <div class="method">
          <img loading="lazy" src="https://libs.coop.ch/logos/payment/pick-up.svg" alt="pick-up" />
        </div>
        <div class="method">
          <img loading="lazy" src="https://libs.coop.ch/logos/payment/twint.svg" alt="twint" />
        </div>
        <div class="method">
          <img loading="lazy" src="https://libs.coop.ch/logos/payment/paycard.svg" alt="paycard" />
        </div>
        <div class="method">
          <img loading="lazy" src="https://libs.coop.ch/logos/payment/invoice.svg" alt="invoice" />
        </div>
        <div class="method">
          <img loading="lazy" src="https://libs.coop.ch/logos/payment/prepayment.svg" alt="prepayment" />
        </div>
        <div class="method">
          <img loading="lazy" src="https://libs.coop.ch/logos/payment/supercard.svg" alt="supercard" />
        </div>
        <div class="method">
          <img loading="lazy" src="https://libs.coop.ch/logos/payment/visa.svg" alt="visa" />
        </div>
        <div class="method">
          <img loading="lazy" src="https://libs.coop.ch/logos/payment/mastercard.svg" alt="mastercard" />
        </div>
        <div class="method">
          <img loading="lazy" src="https://libs.coop.ch/logos/payment/amex.svg" alt="amex" />
        </div>
        <div class="method">
          <img loading="lazy" src="https://libs.coop.ch/logos/payment/diners.svg" alt="diners" />
        </div>
        <div class="method">
          <img loading="lazy" src="https://libs.coop.ch/logos/payment/postfinance-card.svg" alt="postfinance" />
        </div>
      </div>
    );
  }
}
